import { ajax } from 'rxjs/ajax';

export const postRouteUpload = (data: FormData) => {
    return ajax({
        method: 'POST',
        url: `${process.env.CMFA_APP_PLATFORM_ORDER_CAPTOR_URL}/routes`,
        body: data,
    });
};
